import { SurveyForm } from 'src/components/model/survey/form';

export const SurveyCreateForm: React.FC = () => {
  return <SurveyForm />;
};
